import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function ReservationReminders() {
  const user = useSelector((s) => s.auth.user);
  const [alerts, setAlerts] = useState([]);
  useEffect(() => {
    setAlerts([]);
    if (!['SHOP_OWNER', 'SHOP_STAFF'].includes(user?.role)) return;
    let active = true;
    const check = async () => {
      try {
        const options = await api.get('/tables/reservation-settings', { skipLoader: true });
        if (!active) return;
        if (!options.data.settings.remindersEnabled || !options.data.settings.enabled) { setAlerts([]); return; }
        const response = await api.get('/tables/reservations', { skipLoader: true });
        if (!active) return;
        const upcoming = response.data.reservations.filter((r) => ['PENDING', 'CONFIRMED', 'PREPARING'].includes(r.status) && new Date(r.startsAt) > Date.now() && new Date(r.startsAt) - Date.now() <= 3600000);
        const warnings = upcoming.filter((r) => {
          const key = `reservation-alert:${user.shopId}:${r._id}`;
          const slot = Math.floor((3600000 - (new Date(r.startsAt) - Date.now())) / 300000);
          if (sessionStorage.getItem(key) === String(slot)) return false;
          sessionStorage.setItem(key, String(slot));
          return true;
        });
        setAlerts((previous) => [...previous.filter((r) => upcoming.some((u) => u._id === r._id) && !warnings.some((w) => w._id === r._id)), ...warnings]);
      } catch { /* Retry on the next poll after temporary connection failures. */ }
    };
    check();
    const timer = setInterval(check, 30000);
    return () => { active = false; clearInterval(timer); };
  }, [user?.id, user?.shopId, user?.role]);
  return ['SHOP_OWNER', 'SHOP_STAFF'].includes(user?.role) && alerts.length ? <div className="p-3" aria-live="polite">{alerts.map((r) => <Alert variant="warning" key={r._id} dismissible onClose={() => setAlerts((p) => p.filter((a) => a._id !== r._id))}><strong>Guest arriving at {new Date(r.startsAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</strong><div>{r.customerName} / {r.seats} guests / {r.tableNumber ? `Table ${r.tableNumber}` : 'Table assignment required'}. <Link to="/dashboard/tables">Review reservation and start preparation</Link></div></Alert>)}</div> : null;
}
